module.exports = __webpack_public_path__ + "static/media/Chris_Headshot.63b7a2f3.png";